import { render, staticRenderFns } from "./x-chart.vue?vue&type=template&id=29a6a470&"
import script from "./x-chart.vue?vue&type=script&lang=ts&"
export * from "./x-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports